import React, { useState } from 'react';


interface LockerDetailsSearchProps {
    searchTerm: string
    setSearchValue: (searchTerm: string) => void
}

const LockerDetailsSearch = ({searchTerm="", setSearchValue}:LockerDetailsSearchProps) => {
    const [searchTerms, setSearchTerms] = useState<string>(searchTerm);
    
    return (
        <section className="search-and-filter-wrapper">
            <label className='sr-only' htmlFor='locker-details-search-input'>Search for files</label>
            <div className="locker-details-search-input-wrapper">
                <input
                    id="locker-details-search-input"
                    type="text"
                    className="locker-details-search-input"
                    placeholder="Search by file name" 
                    value={searchTerms}
                    onChange={e => setSearchTerms(e.target.value)}
                    onKeyDown={(e:React.KeyboardEvent) => {
                        if(e.key === 'Enter') {
                            setSearchValue(searchTerms);
                        }
                    }}
                />
                {(searchTerms)  && 
                    <button 
                        className="clear-search"
                        onClick={()=> {
                            setSearchValue('');
                            setSearchTerms('');
                    }}>X</button>
                }
            </div>
            
            <button
                className="locker-details-button"
                disabled={!searchTerms}
                onClick={() =>  setSearchValue(searchTerms)}
            > 
                Search
            </button>
        </section>
        )
}
    

export default LockerDetailsSearch
